// @flow

import SaveIcon from "@mui/icons-material/Save";
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import {
	Accordion, AccordionDetails, AccordionSummary,
	CardActions,
	CardContent,
	FormControl,
	FormControlLabel, FormHelperText,
	FormLabel,
	Radio,
	RadioGroup,
	TextField, Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid2";
import { DatePicker } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import { ErrorMessage, FormikProvider } from "formik";
import React, { useMemo, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import InfoIcon from "../../../assets/warning/infoIcon";
import SectionDivider from "../../../components/app/sectionDivider/sectionDivider";
import FormBoxTitle from "../../../components/mui/app/formBoxTitle/formBoxTitle";
import Card1 from "../../../components/mui/general/cards/card1/card1";
import { checkListOptions, monthlyCheckListOptions, trimesterCheckListOptions } from "../../../helpers/constants";
import { formControlDefaults, textFieldDefaults } from "../../../helpers/theme/defaultProps";
import useCheckListsForm from "../../../hooks/checkLists/useCheckListsForm";
import useUserData from "../../../hooks/user/useUserData";
import { CHECKLISTS } from "../../../locales/pages/namespaces";
import CleaningInstructionList from "./cleaningInstructionList";
import InfoPopOver from "./infoPopOver";

type Props = {};

const gridRadioGroupPadding = {
	paddingLeft: 2,
	paddingRight: 2
}

const gridCommentPadding = {
	paddingLeft: 2.5,
	paddingRight: 2.5
}

function ExpandMoreIcon() {
	return null;
}

const Form = (props: Props) => {
	const { checkList } = props
	
	const { t } = useTranslation(CHECKLISTS)
	const { dateFormat } = useUserData()
	const { formik, loadingSubmit } = useCheckListsForm({ checkList })
	const values = useMemo(() => formik.values, [formik.values])
	const [infoPopOver, setInfoPopOver] = useState({
		anchorEl: null,
		open: false,
		body: ''
	})
	const handleInfoPopOver = (value) => {
		setInfoPopOver({ ...value })
	}
	const dateFrom = useMemo(() => (values.activeFromDt ? dayjs(values.activeFromDt).format(dateFormat) : ''), [values.activeFromDt, dateFormat])
	const dateTo = useMemo(() => (values.activeToDt ? dayjs(values.activeToDt).format(dateFormat) : ''), [values.activeToDt, dateFormat])
	
	const radioGroupOptions = useMemo(() => (
		checkListOptions.map(option => (
			<FormControlLabel key={option.value} value={option.value} control={<Radio/>}
							  label={t(option.label)}/>
		))
	), [t])
	const monthlyRadioGroupOptions = useMemo(() => (
		monthlyCheckListOptions.map(option => (
			<FormControlLabel key={option.value} value={option.value} control={<Radio/>}
							  label={t(option.label)}/>
		))
	), [t])
	
	const trimesterRadioGroupOptions = useMemo(() => (
		trimesterCheckListOptions.map(option => (
			<FormControlLabel key={option.value} value={option.value} control={<Radio/>}
							  label={t(option.label)}/>
		))
	), [t])
	
	return (
		<FormikProvider value={formik}>
			<Box
				component={'form'}
				autoComplete="off"
				onSubmit={formik.handleSubmit}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					width: '100%',
					justifyContent: "center",
					alignItems: "center",
					mt: 1,
					px: { sm: 0, md: 1, lg: 2 }
				}}
			>
				<Grid size={12}>
					<Alert severity="info" sx={{ alignItems: 'center' }}>
						<AlertTitle sx={{ alignSelf: 'end' }}>{t('submission_dates', {
							dateFrom: dateFrom,
							dateTo: dateTo
						})}</AlertTitle>
					</Alert>
				</Grid>
				{/*--------------------Ημερήσιες Εργασίες-------------------------*/}
				<Accordion
					defaultExpanded
					sx={{
						position: 'initial',
						borderRadius: '15px 15px 15px 15px !important',
						backgroundColor: '#f0eef5',
						width: '95%',
						marginTop: '5px'
					}}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon/>}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography
							variant={'subtitle2'}
							component={'div'}
							p={0.4}
						>
							{t('Daily Cleaning Service')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails sx={{ backgroundColor: "#ffffffc4", borderRadius: "10px", p: 2 }}>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucDailyTasks"
								name="ucDailyTasks"
								value={values.ucDailyTasks}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{radioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucDailyComment`}
										value={values.ucDailyComment}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Empty all waste baskets into plastic bags. Then place the plastic bags in the waste & recycling collection area')}*/}
							{/*</Typography>*/}
							{/*<RadioGroup*/}
							{/*	aria-labelledby="radio-buttons-group-binTasks"*/}
							{/*	name="binTasks"*/}
							{/*	value={values.binTasks}*/}
							{/*	onChange={formik.handleChange}*/}
							{/*	onBlur={formik.handleBlur}*/}
							{/*>*/}
							{/*	{radioGroupOptions}*/}
							{/*</RadioGroup>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`binComment`}*/}
							{/*			value={values.binComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						
						{/*<Divider sx={{ my: 2 }}/>*/}
						
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('It is noted that waste collection will be done by placing plastic bags in the special waste bins in accordance with the current cleanliness regulations of each Municipality. Specifically for the recycling of paper, plastic, aluminum and empty toners, daily collection is required from the bins located within the Buildings and gathering at a central point within the building in order to subsequently be collected by the recycling company collaborating with the Bank. For Branches where there are no recycling bins installed, the materials should be disposed of in the relevant recycling bins of each Municipality.')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-wasteCollection"*/}
						{/*		name="wasteCollection"*/}
						{/*		value={values.wasteCollection}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`wasteCollectionComment`}*/}
						{/*				value={values.wasteCollectionComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						
						{/*<Divider sx={{ my: 2 }}/>*/}
						
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Thoroughly clean all furniture, including the Director`s & Executives office(s)')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-furniture"*/}
						{/*		name="furniture"*/}
						{/*		value={values.furniture}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`furnitureComment`}*/}
						{/*				value={values.furnitureComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						
						{/*<Divider sx={{ my: 2 }}/>*/}
						
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the bowls and lids inside and out and disinfect with a special liquid')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-bowlsAndLids"*/}
						{/*		name="bowlsAndLids"*/}
						{/*		value={values.bowlsAndLids}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`bowlsAndLidsComment`}*/}
						{/*				value={values.bowlsAndLidsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Sweep the floor, pick up the trash and take it to the trash collection area')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-sweepTheFloor"*/}
						{/*		name="sweepTheFloor"*/}
						{/*		value={values.sweepTheFloor}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`sweepTheFloorComment`}*/}
						{/*				value={values.sweepTheFloorComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Mop the floor thoroughly using water with disinfectant liquid')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-mopTheFloor"*/}
						{/*		name="mopTheFloor"*/}
						{/*		value={values.mopTheFloor}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`mopTheFloorComment`}*/}
						{/*				value={values.mopTheFloorComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Change the toilet paper, if necessary, hand soap, etc. with materials that the "Bank" will provide you')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-toiletPaper"*/}
						{/*		name="toiletPaper"*/}
						{/*		value={values.toiletPaper}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`toiletPaperComment`}*/}
						{/*				value={values.toiletPaperComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the sinks and faucets, wipe with a damp cloth, and polish their metals')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-cleanTheSinks"*/}
						{/*		name="cleanTheSinks"*/}
						{/*		value={values.cleanTheSinks}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanTheSinksComment`}*/}
						{/*				value={values.cleanTheSinksComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean hand dryers and any other related machines')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-cleanHandDryers"*/}
						{/*		name="cleanHandDryers"*/}
						{/*		value={values.cleanHandDryers}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanHandDryersComment`}*/}
						{/*				value={values.cleanHandDryersComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('In the kitchens, wash the cups, glasses, the coffee maker, the counter, and the outside of the cabinets')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-washTheCups"*/}
						{/*		name="washTheCups"*/}
						{/*		value={values.washTheCups}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`washTheCupsComment`}*/}
						{/*				value={values.washTheCupsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Sweep the sidewalk in front of the Store and clean the ATM(s) (screen, keyboard, etc.)')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-sweepTheSidewalk"*/}
						{/*		name="sweepTheSidewalk"*/}
						{/*		value={values.sweepTheSidewalk}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`sweepTheSidewalkComment`}*/}
						{/*				value={values.sweepTheSidewalkComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Sweeping the elevators and maintaining the cleanliness of their walls, buttons/handrails, doors and mirrors with disinfectant liquid')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-sweepElevators"*/}
						{/*		name="sweepElevators"*/}
						{/*		value={values.sweepElevators}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`sweepElevatorsComment`}*/}
						{/*				value={values.sweepElevatorsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Sweep the floors with a vacuum cleaner and all office furniture up to the standard height of 2.00 m.')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-sweepFloorsWithVacuumCleaner"*/}
						{/*		name="sweepFloorsWithVacuumCleaner"*/}
						{/*		value={values.sweepFloorsWithVacuumCleaner}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`sweepFloorsWithVacuumCleanerComment`}*/}
						{/*				value={values.sweepFloorsWithVacuumCleanerComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Vacuum all carpeted areas. Pay attention to corners and especially around shared machines, e.g. photocopiers, fax machines, etc.')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-vacuumCarpetedAreas"*/}
						{/*		name="vacuumCarpetedAreas"*/}
						{/*		value={values.vacuumCarpetedAreas}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`vacuumCarpetedAreasComment`}*/}
						{/*				value={values.vacuumCarpetedAreasComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the floors with a special liquid to remove previous marks and dirt. After sweeping the floor areas (marble, mosaics, etc.), the floors should be wiped with a sponge soaked in soap and water/cleaning liquid. Be careful, marble should only be cleaned with soap and water and not with chlorine.')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-cleanFloorsWithSpecialLiquid"*/}
						{/*		name="cleanFloorsWithSpecialLiquid"*/}
						{/*		value={values.cleanFloorsWithSpecialLiquid}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanFloorsWithSpecialLiquidComment`}*/}
						{/*				value={values.cleanFloorsWithSpecialLiquidComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Using a feather duster, dust the folders and all visible books')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-dustTheFolders"*/}
						{/*		name="dustTheFolders"*/}
						{/*		value={values.dustTheFolders}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`dustTheFoldersComment`}*/}
						{/*				value={values.dustTheFoldersComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the phones with alcohol and the terminal screens only with a dry cloth')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-cleanThePhones"*/}
						{/*		name="cleanThePhones"*/}
						{/*		value={values.cleanThePhones}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanThePhonesComment`}*/}
						{/*				value={values.cleanThePhonesComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Dust the bookcases and care for the wooden furniture with a special spray')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-dustBookcases"*/}
						{/*		name="dustBookcases"*/}
						{/*		value={values.dustBookcases}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`dustBookcasesComment`}*/}
						{/*				value={values.dustBookcasesComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean and polish the metal filing cabinets with a dry cloth and the mirrors with a special spray')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-cleanMetals"*/}
						{/*		name="cleanMetals"*/}
						{/*		value={values.cleanMetals}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanMetalsComment`}*/}
						{/*				value={values.cleanMetalsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the entrance doors with disinfectant and remove any fingerprints')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-cleanEntranceDoors"*/}
						{/*		name="cleanEntranceDoors"*/}
						{/*		value={values.cleanEntranceDoors}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanEntranceDoorsComment`}*/}
						{/*				value={values.cleanEntranceDoorsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Where possible, clean marks, fingerprints, etc. on walls, doors, glass partitions, etc. up to the normal height of 2.00m.')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-cleanFingerPrints"*/}
						{/*		name="cleanFingerPrints"*/}
						{/*		value={values.cleanFingerPrints}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanFingerPrintsComment`}*/}
						{/*				value={values.cleanFingerPrintsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Dust plant pots with special care and avoid pouring dirty water on the flowers')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-dustPlantPots"*/}
						{/*		name="dustPlantPots"*/}
						{/*		value={values.dustPlantPots}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`dustPlantPotsComment`}*/}
						{/*				value={values.dustPlantPotsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Dust and wipe the interior window sills')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-dustWindowSills"*/}
						{/*		name="dustWindowSills"*/}
						{/*		value={values.dustWindowSills}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`dustWindowSillsComment`}*/}
						{/*				value={values.dustWindowSillsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Sweep and mop the stairs and landings, paying special attention to their sides and handrails')}*/}
						{/*	</Typography>*/}
						{/*	<RadioGroup*/}
						{/*		aria-labelledby="radio-buttons-group-sweepAndMopStairs"*/}
						{/*		name="sweepAndMopStairs"*/}
						{/*		value={values.sweepAndMopStairs}*/}
						{/*		onChange={formik.handleChange}*/}
						{/*		onBlur={formik.handleBlur}*/}
						{/*	>*/}
						{/*		{radioGroupOptions}*/}
						{/*	</RadioGroup>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`sweepAndMopStairsComment`}*/}
						{/*				value={values.sweepAndMopStairsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
					</AccordionDetails>
				</Accordion>
				
				
				{/*--------------------Εβδομαδίαιες Εργασίες-------------------------*/}
				<Accordion
					defaultExpanded
					sx={{
						position: 'initial',
						borderRadius: '15px 15px 15px 15px !important',
						backgroundColor: '#f0eef5',
						width: '95%',
						marginTop: '5px'
					}}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon/>}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography
							variant={'subtitle2'}
							component={'div'}
							p={0.4}
						>
							{t('Weekly Cleaning Service')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails sx={{ backgroundColor: "#ffffffc4", borderRadius: "10px", p: 2 }}>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucWeeklyTasks"
								name="ucWeeklyTasks"
								value={values.ucWeeklyTasks}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{radioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucWeeklyComment`}
										value={values.ucWeeklyComment}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Clean the glass in the bookcases, doors, dividers, counters and in the Meeting room and dust all the paintings (paintings, etc.)')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['glassOfBookcasesDay1'] &&*/}
							{/*			Boolean(formik.errors['glassOfBookcasesDay1'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Day 1')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="glassOfBookcasesDay1"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.glassOfBookcasesDay1}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('glassOfBookcasesDay1', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'glassOfBookcasesDay1'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['glassOfBookcasesDay2'] &&*/}
							{/*			Boolean(formik.errors['glassOfBookcasesDay2'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Day 2')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="glassOfBookcasesDay2"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.glassOfBookcasesDay2}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('glassOfBookcasesDay2', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'glassOfBookcasesDay2'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*	*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['glassOfBookcasesDay3'] &&*/}
							{/*			Boolean(formik.errors['glassOfBookcasesDay3'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Day 3')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="glassOfBookcasesDay3"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.glassOfBookcasesDay3}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('glassOfBookcasesDay3', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'glassOfBookcasesDay3'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['glassOfBookcasesDay4'] &&*/}
							{/*			Boolean(formik.errors['glassOfBookcasesDay4'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Day 4')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="glassOfBookcasesDay4"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.glassOfBookcasesDay4}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('glassOfBookcasesDay4', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'glassOfBookcasesDay4'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`glassOfBookcasesComment`}*/}
							{/*			value={values.glassOfBookcasesComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Glossy furniture (formicas, etc.) should be wiped with a suitable liquid and dried')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['glossyFurnitureDay1'] &&*/}
						{/*				Boolean(formik.errors['glossyFurnitureDay1'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 1')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="glossyFurnitureDay1"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.glossyFurnitureDay1}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('glossyFurnitureDay1', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'glossyFurnitureDay1'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['glossyFurnitureDay2'] &&*/}
						{/*				Boolean(formik.errors['glossyFurnitureDay2'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 2')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="glossyFurnitureDay2"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.glossyFurnitureDay2}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('glossyFurnitureDay2', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'glossyFurnitureDay2'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['glossyFurnitureDay3'] &&*/}
						{/*				Boolean(formik.errors['glossyFurnitureDay3'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 3')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="glossyFurnitureDay3"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.glossyFurnitureDay3}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('glossyFurnitureDay3', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'glossyFurnitureDay3'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['glossyFurnitureDay4'] &&*/}
						{/*				Boolean(formik.errors['glossyFurnitureDay4'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 4')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="glossyFurnitureDay4"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.glossyFurnitureDay4}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('glossyFurnitureDay4', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'glossyFurnitureDay4'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`glossyFurnitureComment`}*/}
						{/*				value={values.glossyFurnitureComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Wash all the toilet walls')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['toiletWallsDay1'] &&*/}
						{/*				Boolean(formik.errors['toiletWallsDay1'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 1')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="toiletWallsDay1"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.toiletWallsDay1}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('toiletWallsDay1', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'toiletWallsDay1'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['toiletWallsDay2'] &&*/}
						{/*				Boolean(formik.errors['toiletWallsDay2'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 2')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="toiletWallsDay2"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.toiletWallsDay2}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('toiletWallsDay2', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'toiletWallsDay2'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['toiletWallsDay3'] &&*/}
						{/*				Boolean(formik.errors['toiletWallsDay3'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 3')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="toiletWallsDay3"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.toiletWallsDay3}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('toiletWallsDay3', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'toiletWallsDay3'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['toiletWallsDay4'] &&*/}
						{/*				Boolean(formik.errors['toiletWallsDay4'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 4')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="toiletWallsDay4"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.toiletWallsDay4}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('toiletWallsDay4', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'toiletWallsDay4'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`toiletWallsComment`}*/}
						{/*				value={values.toiletWallsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the photocopiers')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanPhotocopiersDay1'] &&*/}
						{/*				Boolean(formik.errors['cleanPhotocopiersDay1'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 1')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanPhotocopiersDay1"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanPhotocopiersDay1}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanPhotocopiersDay1', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanPhotocopiersDay1'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanPhotocopiersDay2'] &&*/}
						{/*				Boolean(formik.errors['cleanPhotocopiersDay2'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 2')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanPhotocopiersDay2"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanPhotocopiersDay2}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanPhotocopiersDay2', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanPhotocopiersDay2'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanPhotocopiersDay3'] &&*/}
						{/*				Boolean(formik.errors['cleanPhotocopiersDay3'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 3')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanPhotocopiersDay3"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanPhotocopiersDay3}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanPhotocopiersDay3', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanPhotocopiersDay3'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanPhotocopiersDay4'] &&*/}
						{/*				Boolean(formik.errors['cleanPhotocopiersDay4'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 4')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanPhotocopiersDay4"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanPhotocopiersDay4}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanPhotocopiersDay4', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanPhotocopiersDay4'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanPhotocopiersComment`}*/}
						{/*				value={values.cleanPhotocopiersComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider sx={{ my: 2 }}/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the surrounding building exterior and balconies where available')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanSurroundingBuildDay1'] &&*/}
						{/*				Boolean(formik.errors['cleanSurroundingBuildDay1'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 1')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanSurroundingBuildDay1"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanSurroundingBuildDay1}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanSurroundingBuildDay1', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanSurroundingBuildDay1'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanSurroundingBuildDay2'] &&*/}
						{/*				Boolean(formik.errors['cleanSurroundingBuildDay2'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 2')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanSurroundingBuildDay2"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanSurroundingBuildDay2}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanSurroundingBuildDay2', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanSurroundingBuildDay2'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanSurroundingBuildDay3'] &&*/}
						{/*				Boolean(formik.errors['cleanSurroundingBuildDay3'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 3')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanSurroundingBuildDay3"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanSurroundingBuildDay3}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanSurroundingBuildDay3', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanSurroundingBuildDay3'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['cleanSurroundingBuildDay4'] &&*/}
						{/*				Boolean(formik.errors['cleanSurroundingBuildDay4'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Day 4')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="cleanSurroundingBuildDay4"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.cleanSurroundingBuildDay4}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('cleanSurroundingBuildDay4', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'cleanSurroundingBuildDay4'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`cleanSurroundingBuildComment`}*/}
						{/*				value={values.cleanSurroundingBuildComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
					</AccordionDetails>
				</Accordion>
				
				{/*--------------------Μηνιαίες Εργασίες-------------------------*/}
				<Accordion
					defaultExpanded
					sx={{
						position: 'initial',
						borderRadius: '15px 15px 15px 15px !important',
						backgroundColor: '#f0eef5',
						width: '95%',
						marginTop: '5px'
					}}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon/>}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography
							variant={'subtitle2'}
							component={'div'}
							p={0.4}
						>
							{t('Monthly Cleaning Service')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails sx={{ backgroundColor: "#ffffffc4", borderRadius: "10px", p: 2 }}>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('The store’s facade glazing was cleaned once—both internally and externally—along with the aluminum frames, the illuminated store signage, and—where applicable—any wall-mounted illuminated signs, freestanding signs (monoliths), or illuminated signs mounted on a metal pole at the curb.')} {t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucMonthlyTasks"
								name="ucMonthlyTasks"
								value={values.ucMonthlyTasks}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{radioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucMonthlyComment`}
										value={values.ucMonthlyComment}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Dust the tops of cabinets and shelves above normal height and up to 3 m. Height')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['dustCabinetsDate'] &&*/}
							{/*			Boolean(formik.errors['dustCabinetsDate'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Date')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="dustCabinetsDate"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.dustCabinetsDate}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('dustCabinetsDate', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'dustCabinetsDate'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`dustCabinetsComment`}*/}
							{/*			value={values.dustCabinetsComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						<Divider/>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('The rooftops—where present—were swept, particularly around the areas of the rain gutters.')} {t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucMonthlyTasks2"
								name="ucMonthlyTasks2"
								value={values.ucMonthlyTasks2}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{monthlyRadioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucMonthlyComment2`}
										value={values.ucMonthlyComment2}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Wash the wastebaskets inside and out, clean and polish, bookcases and cupboards')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['wasteBasketsDate'] &&*/}
							{/*			Boolean(formik.errors['wasteBasketsDate'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Date')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="wasteBasketsDate"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.wasteBasketsDate}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('wasteBasketsDate', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'wasteBasketsDate'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`wasteBasketsComment`}*/}
							{/*			value={values.wasteBasketsComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('All furniture that can be moved should be cleaned from behind and underneath')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['movedFurnitureDate'] &&*/}
						{/*				Boolean(formik.errors['movedFurnitureDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="movedFurnitureDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.movedFurnitureDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('movedFurnitureDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'movedFurnitureDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`movedFurnitureComment`}*/}
						{/*				value={values.movedFurnitureComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Vacuum clean the furniture with a cloth and wash plastic furniture with a special liquid')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['vacuumFurnitureDate'] &&*/}
						{/*				Boolean(formik.errors['vacuumFurnitureDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="vacuumFurnitureDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.vacuumFurnitureDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('vacuumFurnitureDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'vacuumFurnitureDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`vacuumFurnitureComment`}*/}
						{/*				value={values.vacuumFurnitureComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean the window blinds')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['windowBlindsDate'] &&*/}
						{/*				Boolean(formik.errors['windowBlindsDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="windowBlindsDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.windowBlindsDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('windowBlindsDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'windowBlindsDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`windowBlindsComment`}*/}
						{/*				value={values.windowBlindsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean all auxiliary areas (engine rooms, warehouses, parking lots, etc.)')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['auxiliaryAreasDate'] &&*/}
						{/*				Boolean(formik.errors['auxiliaryAreasDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="auxiliaryAreasDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.auxiliaryAreasDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('auxiliaryAreasDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'auxiliaryAreasDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`auxiliaryAreasComment`}*/}
						{/*				value={values.auxiliaryAreasComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Clean and wash the glass facades of the Store once internally and externally, the aluminum, the bright or illuminated sign of the Store and if there is a wall-mounted light sign, monolith or light sign on a metal pole in the sidewalk kennel')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['glassFacadesDate'] &&*/}
						{/*				Boolean(formik.errors['glassFacadesDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="glassFacadesDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.glassFacadesDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('glassFacadesDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'glassFacadesDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`glassFacadesComment`}*/}
						{/*				value={values.glassFacadesComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Wipe the roofs where they exist, especially in the gutter areas')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['wipeRoofsDate'] &&*/}
						{/*				Boolean(formik.errors['wipeRoofsDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="wipeRoofsDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.wipeRoofsDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('wipeRoofsDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'wipeRoofsDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`wipeRoofsComment`}*/}
						{/*				value={values.wipeRoofsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
					</AccordionDetails>
				</Accordion>
				
				{/*--------------------3Μηνιαίες Εργασίες-------------------------*/}
				<Accordion
					defaultExpanded
					sx={{
						position: 'initial',
						borderRadius: '15px 15px 15px 15px !important',
						backgroundColor: '#f0eef5',
						width: '95%',
						marginTop: '5px'
					}}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon/>}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography
							variant={'subtitle2'}
							component={'div'}
							p={0.4}
						>
							{t('Trimister Cleaning Service')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails sx={{ backgroundColor: "#ffffffc4", borderRadius: "10px", p: 2 }}>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('The security shutters were washed, always in consultation with the store management.')} {t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucTrimesterTasks"
								name="ucTrimesterTasks"
								value={values.ucTrimesterTasks}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{trimesterRadioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucTrimesterComment`}
										value={values.ucTrimesterComment}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('In a multi-storey building where special means are required for the external cleaning of the windows (e.g. scaffolding or other means), the Contractor will clean them by taking the necessary safety measures according to the instructions received from the Bank and the labor legislation, in order to avoid accidents')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['multiStoreyDate'] &&*/}
							{/*			Boolean(formik.errors['multiStoreyDate'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Date')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="multiStoreyDate"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.multiStoreyDate}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('multiStoreyDate', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'multiStoreyDate'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`multiStoreyComment`}*/}
							{/*			value={values.multiStoreyComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						<Divider/>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('The office carpeting, as well as resilient flooring (e.g., PVC-type), granite flooring, etc., were cleaned using mechanical equipment.')} {t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucTrimesterTasks2"
								name="ucTrimesterTasks2"
								value={values.ucTrimesterTasks2}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{radioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucTrimesterComment2`}
										value={values.ucTrimesterComment2}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Always wash the security shutters in consultation with the Branch Manager who will inform you of the time when the specific work will be carried out')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['securityShuttersDate'] &&*/}
							{/*			Boolean(formik.errors['securityShuttersDate'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Date')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="securityShuttersDate"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.securityShuttersDate}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('securityShuttersDate', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'securityShuttersDate'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`securityShuttersComment`}*/}
							{/*			value={values.securityShuttersComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Wash the office carpets as well as the plastic floors (e.g. PVC type), granites, etc. with mechanical means')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['officeCarpetsDate'] &&*/}
						{/*				Boolean(formik.errors['officeCarpetsDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="officeCarpetsDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.officeCarpetsDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('officeCarpetsDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'officeCarpetsDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`officeCarpetsComment`}*/}
						{/*				value={values.officeCarpetsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Wash the inside of the kitchen cabinets')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['kitchenCabinetsDate'] &&*/}
						{/*				Boolean(formik.errors['kitchenCabinetsDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="kitchenCabinetsDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.kitchenCabinetsDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('kitchenCabinetsDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'kitchenCabinetsDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`kitchenCabinetsComment`}*/}
						{/*				value={values.kitchenCabinetsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
					</AccordionDetails>
				</Accordion>
				
				{/*--------------------Ετήσιες Εργασίες-------------------------*/}
				<Accordion
					defaultExpanded
					sx={{
						position: 'initial',
						borderRadius: '15px 15px 15px 15px !important',
						backgroundColor: '#f0eef5',
						width: '95%',
						marginTop: '5px'
					}}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon/>}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography
							variant={'subtitle2'}
							component={'div'}
							p={0.4}
						>
							{t('Year Cleaning Service')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails sx={{ backgroundColor: "#ffffffc4", borderRadius: "10px", p: 2 }}>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('The seats, false ceilings, upholstery, and exterior marble cladding were washed.')} {t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucYearlyTask"
								name="ucYearlyTask"
								value={values.ucYearlyTask}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{radioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucYearlyComment`}
										value={values.ucYearlyComment}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Wash the seats, false ceilings, upholstery and external marble')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['externalMarbleDate'] &&*/}
							{/*			Boolean(formik.errors['externalMarbleDate'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Date')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="externalMarbleDate"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.externalMarbleDate}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('externalMarbleDate', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'externalMarbleDate'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`externalMarbleComment`}*/}
							{/*			value={values.externalMarbleComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						<Divider/>
						<Box mb={2}>
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
								{t('Mechanical washing of marble floors and staircases was performed, and, if deemed necessary, crystallization was carried out.')} {t('Completed')}:
							</Typography>
							<RadioGroup
								aria-labelledby="radio-buttons-group-ucYearlyTask2"
								name="ucYearlyTask2"
								value={values.ucYearlyTask2}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							>
								{radioGroupOptions}
							</RadioGroup>
							<Grid size={12} sx={gridCommentPadding}>
								<FormControl {...formControlDefaults}>
									<FormLabel>{t('Comments')}</FormLabel>
									<TextField
										{...textFieldDefaults}
										name={`ucYearlyComment2`}
										value={values.ucYearlyComment2}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										inputtype="textarea"
										multiline
										rows={3}
									/>
								</FormControl>
							</Grid>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Mechanical washing of marble floors and staircases and, if necessary, their crystallization')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['marbleFloorsDate'] &&*/}
							{/*			Boolean(formik.errors['marbleFloorsDate'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Date')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="marbleFloorsDate"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.marbleFloorsDate}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('marbleFloorsDate', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'marbleFloorsDate'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`marbleFloorsComment`}*/}
							{/*			value={values.marbleFloorsComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
					</AccordionDetails>
				</Accordion>
				
				
				{/*--------------------Εργασίες που διεκπεραιώνονται με χρήση ειδικών μέσων-------------------------*/}
				<Accordion
					defaultExpanded
					sx={{
						position: 'initial',
						borderRadius: '15px 15px 15px 15px !important',
						backgroundColor: '#f0eef5',
						width: '95%',
						marginTop: '5px'
					}}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon/>}
						aria-controls="panel1-content"
						id="panel1-header"
					>
						<Typography
							variant={'subtitle2'}
							component={'div'}
							p={0.4}
						>
							{t('SOFT FM SERVICES – CLEANING OF BANK BUILDINGS AND BRANCHES')}
						</Typography>
					</AccordionSummary>
					<AccordionDetails sx={{ backgroundColor: "#ffffffc4", borderRadius: "10px", p: 2 }}>
						<Box mb={2}>
							{/*
							<Typography variant="body1" sx={{ mb: 1, fontWeight: 700 }}>
								{t('SOFT FM SERVICES – CLEANING OF BANK BUILDINGS AND BRANCHES')}
							</Typography>
							<Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
								{t('Daily Cleaning Duties')}
							</Typography>
							<Trans i18nKey="daily_duties" ns={CHECKLISTS}/>
							<Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 700 }}>
								{t('Weekly Cleaning Duties')}
							</Typography>
							<Trans i18nKey="weekly_duties" ns={CHECKLISTS}/>
							<Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 700 }}>
								{t('Monthly Cleaning Duties')}
							</Typography>
							<Trans i18nKey="monthly_duties" ns={CHECKLISTS}/>
							<Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 700 }}>
								{t('Trimester Cleaning Duties')}
							</Typography>
							<Trans i18nKey="trimester_duties" ns={CHECKLISTS}/>
							*/}
							<CleaningInstructionList/>
							{/*<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
							{/*	{t('Clean and wash the glass facades of the Branch once internally and externally, the aluminum, the luminous or illuminated inscription of the Branch and if there is a wall-mounted luminous sign, monolith or luminous sign on a metal pole in the sidewalk. (monthly)')}*/}
							{/*</Typography>*/}
							{/*<Grid size={12} sx={{*/}
							{/*	paddingLeft: 2.5,*/}
							{/*	paddingRight: 2.5,*/}
							{/*	display: 'flex',*/}
							{/*	flexDirection: 'column'*/}
							{/*}}>*/}
							{/*	<FormControl*/}
							{/*		{...formControlDefaults}*/}
							{/*		error={*/}
							{/*			formik.touched['washGlassDate'] &&*/}
							{/*			Boolean(formik.errors['washGlassDate'])*/}
							{/*		}*/}
							{/*		sx={{ width: '20%' }}*/}
							{/*	>*/}
							{/*		<FormLabel>{t('Date')}</FormLabel>*/}
							{/*		<DatePicker*/}
							{/*			slotProps={{*/}
							{/*				textField: {*/}
							{/*					size: 'small',*/}
							{/*					variant: 'standard'*/}
							{/*				}*/}
							{/*			}}*/}
							{/*			name="washGlassDate"*/}
							{/*			views={['year', 'month', 'day']}*/}
							{/*			format={dateFormat}*/}
							{/*			value={formik.values.washGlassDate}*/}
							{/*			onChange={(newValue) => {*/}
							{/*				formik.setFieldValue('washGlassDate', newValue)*/}
							{/*			}}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*		/>*/}
							{/*		<FormHelperText>*/}
							{/*			<ErrorMessage name={'washGlassDate'}/>*/}
							{/*		</FormHelperText>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
							{/*<Grid size={12} sx={gridCommentPadding}>*/}
							{/*	<FormControl {...formControlDefaults}>*/}
							{/*		<FormLabel>{t('Comments')}</FormLabel>*/}
							{/*		<TextField*/}
							{/*			{...textFieldDefaults}*/}
							{/*			name={`washGlassComment`}*/}
							{/*			value={values.washGlassComment}*/}
							{/*			onChange={formik.handleChange}*/}
							{/*			onBlur={formik.handleBlur}*/}
							{/*			inputtype="textarea"*/}
							{/*			multiline*/}
							{/*			rows={3}*/}
							{/*		/>*/}
							{/*	</FormControl>*/}
							{/*</Grid>*/}
						</Box>
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('In the case of a multi-storey building where special means are required for the external cleaning of the windows (e.g. scaffolding or other means), the Contractor will clean them taking the necessary safety measures according to the instructions received from the Bank and the labor legislation, to avoid accidents. (quarterly)')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['specialMultiStoreyDate'] &&*/}
						{/*				Boolean(formik.errors['specialMultiStoreyDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="specialMultiStoreyDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.specialMultiStoreyDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('specialMultiStoreyDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'specialMultiStoreyDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`specialMultiStoreyComment`}*/}
						{/*				value={values.specialMultiStoreyComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Wash the security shutters always in consultation with the Branch Manager who will inform you of the time when this specific work will be carried out. (quarterly)')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['washSecurityShuttersDate'] &&*/}
						{/*				Boolean(formik.errors['washSecurityShuttersDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="washSecurityShuttersDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.washSecurityShuttersDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('washSecurityShuttersDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'washSecurityShuttersDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`washSecurityShuttersComment`}*/}
						{/*				value={values.washSecurityShuttersComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Wash the office carpets as well as the plastic floors (e.g. PVC type), granites etc. by mechanical means (quarterly)')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['washOfficeCarpetsDate'] &&*/}
						{/*				Boolean(formik.errors['washOfficeCarpetsDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="washOfficeCarpetsDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.washOfficeCarpetsDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('washOfficeCarpetsDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'washOfficeCarpetsDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`washOfficeCarpetsComment`}*/}
						{/*				value={values.washOfficeCarpetsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Wash the seats, false ceilings, upholstery and external marble (annually)')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['washSeatsDate'] &&*/}
						{/*				Boolean(formik.errors['washSeatsDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="washSeatsDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.washSeatsDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('washSeatsDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'washSeatsDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`washSeatsComment`}*/}
						{/*				value={values.washSeatsComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
						{/*<Divider/>*/}
						{/*<Box mb={2}>*/}
						{/*	<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>*/}
						{/*		{t('Mechanical washing of marble floors and staircases and, if necessary, their crystallization (annually)')}*/}
						{/*	</Typography>*/}
						{/*	<Grid size={12} sx={{*/}
						{/*		paddingLeft: 2.5,*/}
						{/*		paddingRight: 2.5,*/}
						{/*		display: 'flex',*/}
						{/*		flexDirection: 'column'*/}
						{/*	}}>*/}
						{/*		<FormControl*/}
						{/*			{...formControlDefaults}*/}
						{/*			error={*/}
						{/*				formik.touched['mechanicalWashingDate'] &&*/}
						{/*				Boolean(formik.errors['mechanicalWashingDatemechanicalWashingDate'])*/}
						{/*			}*/}
						{/*			sx={{ width: '20%' }}*/}
						{/*		>*/}
						{/*			<FormLabel>{t('Date')}</FormLabel>*/}
						{/*			<DatePicker*/}
						{/*				slotProps={{*/}
						{/*					textField: {*/}
						{/*						size: 'small',*/}
						{/*						variant: 'standard'*/}
						{/*					}*/}
						{/*				}}*/}
						{/*				name="mechanicalWashingDate"*/}
						{/*				views={['year', 'month', 'day']}*/}
						{/*				format={dateFormat}*/}
						{/*				value={formik.values.mechanicalWashingDate}*/}
						{/*				onChange={(newValue) => {*/}
						{/*					formik.setFieldValue('mechanicalWashingDate', newValue)*/}
						{/*				}}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*			/>*/}
						{/*			<FormHelperText>*/}
						{/*				<ErrorMessage name={'mechanicalWashingDate'}/>*/}
						{/*			</FormHelperText>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*	<Grid size={12} sx={gridCommentPadding}>*/}
						{/*		<FormControl {...formControlDefaults}>*/}
						{/*			<FormLabel>{t('Comments')}</FormLabel>*/}
						{/*			<TextField*/}
						{/*				{...textFieldDefaults}*/}
						{/*				name={`mechanicalWashingComment`}*/}
						{/*				value={values.mechanicalWashingComment}*/}
						{/*				onChange={formik.handleChange}*/}
						{/*				onBlur={formik.handleBlur}*/}
						{/*				inputtype="textarea"*/}
						{/*				multiline*/}
						{/*				rows={3}*/}
						{/*			/>*/}
						{/*		</FormControl>*/}
						{/*	</Grid>*/}
						{/*</Box>*/}
					</AccordionDetails>
				</Accordion>
			</Box>
			<Grid xs={12} sx={{
				display: 'flex',
				justifyContent: 'flex-end',
				paddingLeft: '16px',
				paddingRight: '16px',
				marginTop: '5px'
			}}>
				<Box sx={{ display: 'flex' }}>
					<FormControl
						{...formControlDefaults}
						error={
							formik.touched['signName'] &&
							Boolean(formik.errors['signName'])
						}
					>
						<FormLabel required>{t('Certified By')}</FormLabel>
						<TextField
							{...textFieldDefaults}
							name={'signName'}
							value={values.signName}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
						/>
						<FormHelperText>
							<ErrorMessage name={'signName'}/>
						</FormHelperText>
					</FormControl>
					
					<Button
						loading={loadingSubmit}
						startIcon={<SaveIcon/>}
						onClick={formik.handleSubmit}
						variant="contained"
						sx={{
							marginLeft: 'auto',
							marginRight: '25px',
							paddingLeft: '30px',
							paddingRight: '25px'
						}}
					>
						{t('Submit')}
					</Button>
				</Box>
			</Grid>
			<InfoPopOver
				infoPopOver={infoPopOver}
				handleInfoPopOver={handleInfoPopOver}
			/>
		</FormikProvider>
	);
};

export default Form